import AuthProvider from 'react-auth-kit'
import createStore from 'react-auth-kit/createStore'

export const AuthContext = ({ children }: { children: JSX.Element }) => {
    const store = createStore({
        authName: '_auth',
        authType: 'localstorage',
        cookieDomain: window.location.hostname,
        cookieSecure: window.location.protocol === 'https:',
    })

    return <AuthProvider store={store}>{children}</AuthProvider>
}
